__turbopack_context__.v({
  "className": "g7T99G_className",
  "variable": "g7T99G_variable",
});
